import styled from '@emotion/styled';
import { Header, Icon, Message } from 'semantic-ui-react';
import { usePermissions } from '@britishcouncil/react-common';

import { FullScreenLoader, PageContent } from 'components';
import { LOGOS } from 'const';
import { useGetPermissionsQuery } from 'store';

export const Welcome = () => {
  const { permissions } = usePermissions();
  const { isError, isSuccess } = useGetPermissionsQuery();
  const permissionsFetched = isError || isSuccess;

  return !permissionsFetched ? (
    <FullScreenLoader text="Loading permissions ..." />
  ) : (
    <PageContent>
      <S.Header as="h1">Examiner Management</S.Header>

      {permissions?.length === 0 && (
        <Message color="yellow">
          <Message.Content>
            <Message.Header>
              <Icon name="warning" /> You don't have any system role assigned in EMM.
            </Message.Header>
            <p>Please, contact L2 team for further information.</p>
          </Message.Content>
        </Message>
      )}
      <S.Logo src={LOGOS.EmmLogoUrl} alt="Examiner Management" />
    </PageContent>
  );
};

const S = {
  Header: styled(Header)`
    &.ui.header {
      text-align: center;
      padding-bottom: 9px;
      margin: 40px 0 20px;
    }
  `,
  Logo: styled.img`
    margin: 0 auto;
    opacity: 0.25;
    filter: grayscale(100%);
    width: 256px;
    height: 256px;
    margin: 0 auto;
    display: block;
  `,
};
